import { Building2, DoorOpen, Hammer, Home, PanelsTopLeft, ShieldCheck, SunMedium, Waves } from 'lucide-react';

export const company = {
  name: 'RS Byg',
  phone: '42 30 79 39',
  phoneHref: 'tel:+4542307939',
  email: 'rsbyg@outlook.dk',
  emailHref: 'mailto:rsbyg@outlook.dk',
  cvr: '46245040',
  address: 'Hornstrupvej 3, 7700 Thisted',
  city: 'Thisted',
  region: 'Thisted og omegn',
};

export const assets = {
  hero: 'https://assets.auxodev.dk/assets/cc07307d-38f2-4d7e-9eca-ab76959f9adc/traeterrasse-dansk-parcelhus.jpg',
  about: 'https://assets.auxodev.dk/assets/cc07307d-38f2-4d7e-9eca-ab76959f9adc/rs-byg-team-portraet.jpg',
  detail: 'https://assets.auxodev.dk/assets/cc07307d-38f2-4d7e-9eca-ab76959f9adc/toemrer-arbejde-detalje.jpg',
  renovation: 'https://assets.auxodev.dk/assets/cc07307d-38f2-4d7e-9eca-ab76959f9adc/renovering-indendoers.jpg',
  windows: 'https://assets.auxodev.dk/assets/cc07307d-38f2-4d7e-9eca-ab76959f9adc/shutterstock-1139360030.jpg',
  roof: 'https://assets.auxodev.dk/assets/cc07307d-38f2-4d7e-9eca-ab76959f9adc/tagudskiftning-dansk-bolig.jpg',
  terrace: 'https://assets.auxodev.dk/assets/cc07307d-38f2-4d7e-9eca-ab76959f9adc/traeterrasse-dansk-parcelhus.jpg',
};

export const navigation = {
  main: [
    { label: 'Forside', to: '/' },
    {
      label: 'Ydelser',
      to: '/ydelser',
      children: [
        { label: 'Træterrasser', to: '/ydelser/traeterrasser' },
        { label: 'Renovering', to: '/ydelser/renovering' },
        { label: 'Tagudskiftning', to: '/ydelser/tagudskiftning' },
        { label: 'Vinduer & Døre', to: '/ydelser/vinduer-og-doere' },
      ],
    },
    { label: 'Galleri', to: '/galleri' },
    { label: 'Om RS Byg', to: '/om-rs-byg' },
    { label: 'Kontakt', to: '/kontakt' },
  ],
  footer: [
    { label: 'Forside', to: '/' },
    { label: 'Ydelser', to: '/ydelser' },
    { label: 'Galleri', to: '/galleri' },
    { label: 'Om RS Byg', to: '/om-rs-byg' },
    { label: 'Kontakt', to: '/kontakt' },
  ],
};

export const serviceCards = [
  {
    label: 'Træterrasser',
    slug: 'traeterrasser',
    to: '/ydelser/traeterrasser',
    icon: Waves,
    description: 'Nye træterrasser og udskiftning af eksisterende løsninger udført med fokus på præcision, materialevalg og holdbarhed.',
    gallerySlug: 'traeterrasser',
    image: assets.terrace,
  },
  {
    label: 'Renovering',
    slug: 'renovering',
    to: '/ydelser/renovering',
    icon: Home,
    description: 'Ombygninger, modernisering og forbedringer af bolig og rum med en professionel og ryddelig proces.',
    gallerySlug: 'renovering',
    image: assets.renovation,
  },
  {
    label: 'Tagudskiftning',
    slug: 'tagudskiftning',
    to: '/ydelser/tagudskiftning',
    icon: SunMedium,
    description: 'Tagrenovering og udskiftning af tag, så huset får en stærk, tæt og æstetisk afslutning.',
    gallerySlug: 'tagudskiftning',
    image: assets.roof,
  },
  {
    label: 'Vinduer & Døre',
    slug: 'vinduer-og-doere',
    to: '/ydelser/vinduer-og-doere',
    icon: DoorOpen,
    description: 'Udskiftning af vinduer og døre med fokus på energi, komfort, finish og en skarp montage.',
    gallerySlug: 'vinduer-og-doere',
    image: assets.windows,
  },
];

export const uspItems = [
  {
    label: 'Kvalitet i håndværket',
    text: 'Vi går aldrig på kompromis med kvaliteten og leverer løsninger, der holder over tid.',
    icon: Hammer,
  },
  {
    label: 'Personlig service',
    text: 'Du har direkte kontakt gennem hele projektet, så forventninger og løsninger er klare fra start til slut.',
    icon: Building2,
  },
  {
    label: 'Lokalt forankret',
    text: 'RS Byg er lokalt forankret i Thisted og arbejder med fokus på tilfredse kunder i området.',
    icon: ShieldCheck,
  },
  {
    label: 'Ordentlig kommunikation',
    text: 'Klar dialog, realistiske forventninger og et professionelt forløb er en naturlig del af samarbejdet.',
    icon: PanelsTopLeft,
  },
];

export const pageMeta = {
  home: {
    title: 'Tømrer i Thisted & Thy | RS Byg - Kvalitet & Faglig Stolthed',
    description:
      'Søger du en tømrer i Thisted, Thy eller omegn? RS Byg v/ Rasmus Sørensen leverer kompromisløst tømrerarbejde, træterrasser, renovering og tagudskiftning.',
    ogImage: assets.hero,
  },
  services: {
    title: 'Tømrerarbejde & Ydelser i Thisted | RS Byg',
    description:
      'Professionelle tømrerydelser i Thisted og Thy. Vi tilbyder opbygning af træterrasser, tagudskiftning, montering af vinduer/døre og totalrenovering.',
    ogImage: assets.terrace,
  },
  gallery: {
    title: 'Galleri & Referencer | Se vores tømrerarbejde | RS Byg',
    description:
      'Se billeder af vores udførte tømrerprojekter i Thisted og Thy. Bliv inspireret af vores træterrasser, renoveringer, tagudskiftninger og detaljer.',
    ogImage: assets.terrace,
  },
  about: {
    title: 'Om RS Byg | Din lokale tømrermester i Thisted & Thy',
    description:
      'Mød tømrermester Rasmus Sørensen, ejeren bag RS Byg i Thisted. Læs om vores faglige stolthed, fokus på detaljer og tætte kundedialog.',
    ogImage: assets.about,
  },
  contact: {
    title: 'Kontakt RS Byg | Få et uforpligtende tilbud fra din tømrer',
    description:
      'Skal vi hjælpe med dit næste tømrerprojekt i Thisted eller Thy? Ring til Rasmus på 42 30 79 39 eller send en besked for et uforpligtende tilbud.',
    ogImage: assets.windows,
  },
  forbidden: {
    title: 'Adgang nægtet - RS Byg',
    description:
      'Du har ikke adgang til denne side. Brug knappen herunder for at gå tilbage til forsiden eller kontakte RS Byg.',
    ogImage: assets.detail,
    noindex: true,
  },
  notFound: {
    title: 'Siden blev ikke fundet - RS Byg',
    description:
      'Den side du søgte, kunne ikke findes. Gå tilbage til forsiden eller se RS Bygs ydelser og galleri.',
    ogImage: assets.terrace,
    noindex: true,
  },
};

export const servicePages = {
  'traeterrasser': {
    label: 'Træterrasser',
    title: 'Træterrasser',
    slug: 'traeterrasser',
    gallerySlug: 'traeterrasser',
    heroImage: assets.terrace,
    meta: {
      title: 'Opbygning af træterrasse i Thisted & Thy | RS Byg',
      description: 'Få bygget en smuk og holdbar træterrasse tilpasset din bolig og det danske klima. RS Byg sikrer præcision, flot finish og kvalitetsmaterialer.',
      ogImage: assets.terrace,
    },
    intro: 'En træterrasse skal være både smuk, funktionel og bygget til det danske klima. RS Byg leverer gennemførte løsninger, hvor linjer, samlinger og materialer går op i en højere enhed.',
    points: [
      'Design af træterrasser',
      'Nye terrasser',
      'Udskiftning af eksisterende terrasser',
      'Materialevalg',
      'Vedligeholdelsesvenlige løsninger',
    ],
    cta: 'Få et tilbud på din træterrasse',
    ctaPath: '/kontakt',
  },
  renovering: {
    label: 'Renovering',
    title: 'Renovering',
    slug: 'renovering',
    gallerySlug: 'renovering',
    heroImage: assets.renovation,
    meta: {
      title: 'Professionel renovering & ombygning i Thisted | RS Byg',
      description: 'Giv din bolig nyt liv med en professionel renovering. Vi udfører alt fra modernisering til større ombygninger i Thisted og Thy med stor ryddelighed.',
      ogImage: assets.renovation,
    },
    intro: 'Renovering kræver overblik, håndværksmæssig ro og en løsning, der passer til boligens helhed. RS Byg udfører både mindre forbedringer og større ombygninger med fokus på kvalitet i hver eneste detalje.',
    points: [
      'Ombygninger',
      'Modernisering',
      'Boligforbedringer',
      'Indvendige og udvendige projekter',
    ],
    cta: 'Tal med os om din renovering',
    ctaPath: '/kontakt',
  },
  tagudskiftning: {
    label: 'Tagudskiftning',
    title: 'Tagudskiftning',
    slug: 'tagudskiftning',
    gallerySlug: 'tagudskiftning',
    heroImage: assets.roof,
    meta: {
      title: 'Nyt tag & tagudskiftning i Thisted & Thy | RS Byg',
      description: 'Trænger huset til nyt tag? RS Byg udfører professionel tagudskiftning og tagrenovering med fokus på tæthed, holdbarhed og flot æstetisk finish.',
      ogImage: assets.roof,
    },
    intro: 'Et nyt tag er en af de vigtigste investeringer i boligen. RS Byg leverer tagudskiftning og tagrenovering, hvor holdbarhed, tæthed og finish er i centrum.',
    points: [
      'Nyt tag',
      'Tagrenovering',
      'Tagudskiftning',
      'Holdbare løsninger',
    ],
    cta: 'Få et tilbud på tagudskiftning',
    ctaPath: '/kontakt',
  },
  'vinduer-og-doere': {
    label: 'Vinduer & Døre',
    title: 'Vinduer & Døre',
    slug: 'vinduer-og-doere',
    gallerySlug: 'vinduer-og-doere',
    heroImage: assets.windows,
    meta: {
      title: 'Udskiftning af vinduer & døre i Thisted | RS Byg',
      description: 'Spar på varmeregningen med nye energivenlige vinduer og døre. Vi sikrer præcis opmåling, montering og en perfekt finish på din bolig i Thy.',
      ogImage: assets.windows,
    },
    intro: 'Nye vinduer og døre skal forbedre både komfort, energiforbrug og husets udtryk. RS Byg sørger for en præcis montage og en løsning, der passer til boligen.',
    points: [
      'Udskiftning af vinduer',
      'Nye døre',
      'Energivenlige løsninger',
      'Forbedret komfort og udseende',
    ],
    cta: 'Få et tilbud på vinduer og døre',
    ctaPath: '/kontakt',
  },
};

export const galleryFilters = [
  { label: 'Alle projekter', value: '' },
  { label: 'Træterrasser', value: 'traeterrasser' },
  { label: 'Renovering', value: 'renovering' },
  { label: 'Tagudskiftning', value: 'tagudskiftning' },
  { label: 'Vinduer & Døre', value: 'vinduer-og-doere' },
];

export const testimonialMeta = {
  title: 'Anmeldelser - RS Byg',
  description: 'Læs kundernes oplevelser med RS Byg og vores arbejde med træterrasser, renovering, tagudskiftning samt vinduer og døre.',
  ogImage: assets.detail,
};

export const homeHighlights = [
  {
    title: 'Tømrerarbejde med præcision',
    text: 'Vi leverer solide løsninger, som både er flotte at se på og bygget til at holde.',
  },
  {
    title: 'Lokalt kendskab',
    text: 'Som tømrer i Thisted og omegn kender vi både boligerne, behovene og de praktiske krav til arbejdet.',
  },
  {
    title: 'Projekter fra idé til færdigt resultat',
    text: 'Vi hjælper med alt fra rådgivning og materialevalg til den afsluttende finish.',
  },
];
